import { z } from 'zod'

export const zAllFavoriteListIdsByProductsResponse = z.object({
  favoriteListIds: z.array(z.string()),
  productIds: z.string(),
})

export type AllFavoriteListIdsByProducts = z.infer<typeof zAllFavoriteListIdsByProductsResponse>
